import { SnapshotEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Button } from "@flat-ui";
import { getSphereViewerUrl } from "@utils/project-utils";
import { useProjectApiClient } from "@api/project-api/use-project-api-client";
import { IElementType, IElementTypeHint } from "@faro-lotv/ielement-types";
import { useState } from "react";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { useHasValidFeatureProjectLevel } from "@hooks/feature-control/use-has-user-valid-feature-project-level";
/** Renders the create snapshot button and handles redirection to create snapshot page */
export function CreateSnapshot({
  projectId,
  variant = "secondary"
}) {
  const {
    trackEvent
  } = useTrackEvent();
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const projectApiClient = useProjectApiClient({
    projectId
  });
  const {
    canCreateSnapshot
  } = useHasValidFeatureProjectLevel();
  const [isLoading, setIsLoading] = useState(false);
  async function onClick() {
    trackEvent({
      name: SnapshotEvents.createSnapshot
    });
    setIsLoading(true);
    try {
      // Fetch area IElements to provide area id as param
      const areas = await projectApiClient.getAllIElements({
        type: IElementType.section,
        typeHints: [IElementTypeHint.area]
      });
      const firstAreaId = areas[0]?.id;
      const targetHref = getSphereViewerUrl({
        projectId,
        id: firstAreaId,
        additionalParams: new URLSearchParams({
          tool: "createSnapshot"
        })
      });

      // Redirect to create snapshot page
      window.open(targetHref, "_self");
    } catch (error) {
      handleErrorWithToast({
        id: `createSnapshot-${Date.now().toString()}`,
        title: "Could not redirect to create snapshot",
        error
      });
    } finally {
      setIsLoading(false);
    }
  }
  if (!canCreateSnapshot) {
    return null;
  }
  return <Button onClick={onClick} isLoading={isLoading} variant={isScreenSmOrSmaller ? "primary" : variant} sx={{
    width: isScreenSmOrSmaller ? "100%" : "auto"
  }}>
      Create snapshot
    </Button>;
}